{
  "app": {
    "title": "Rechnungsstellung",
    "close_button": "Schließen",
    "loading": "Wird geladen..."
  },
  "orders_dashboard": {
    "title": "Bestellungen",
    "filter_all": "Alle",
    "filter_unassigned": "Nicht zugewiesen",
    "filter_expiring": "Läuft ab",
    "filter_undeployed": "Verfügbar zur Bereitstellung",
    "filter_canActivate": "Verfügbar zur Aktivierung",
    "search_orders": "Suchaufträge"
  },
  "orders_list": {
    "subscriptionExpiry": "ABONNEMENTABLAUF",
    "end_of_orders_list": "Ende der Bestellliste",
    "orderDate": "BESTELLDATUM",
    "orderNumber": "BESTELLNUMMER",
    "subscriptionNumber": "ABONNEMENTNUMMER",
    "accountName": "ZUGEORDNETES KONTO",
    "unassigned": "Nicht zugewiesen",
    "unavailable": "Nicht verfügbar",
    "expiring": "LÄUFT DEMNÄCHST AB",
    "assign": "ZUWEISEN",
    "expired": "ABGELAUFEN",
    "perpetual": "UNBEFRISTET",
    "pending": "AKTIVIERUNG AUSSTEHEND",
    "error_retrieving_orders": "Es gab einen Fehler beim Abrufen der Aufträge.",
    "no_orders_found": "Keine Aufträge gefunden.",
    "deploy": "Bereitstellen",
    "activate": "Aktivieren"
  },
  "order_details": {
    "deploy_button": "Bereitstellen",
    "activate_button": "Aktivieren",
    "assign_button": "Zuweisen",
    "order_number": "Bestellung #",
    "tracking_number": "Tracking-Nummer",
    "subscription_number": "Abonnement Nr.",
    "see_additional_details": "Siehe zusätzliche Tracking-Details",
    "hide_additional_details": "Siehe zusätzliche Tracking-Details",
    "po_number": "Bestellnummer",
    "reseller_SAP_Id": "SAP-ID des Vertriebspartners",
    "sapOrderId": "SAP-Auftrag-ID",
    "order_assigned_to": "Auftragszuordnung zu",
    "start_date": "Startdatum",
    "term": "Laufzeit",
    "please_pick_acct_msg": "Wir konnten diese Bestellung nicht zuordnen, also wählen Sie bitte manuell ein Konto aus, auf das Sie es anwenden möchten.",
    "company": "Unternehmen",
    "create_new_account": "Erstellen Sie ein neues Konto",
    "order_expiry_time": "DER AUFTRAG WIRD INNERHALB VON {{numdays}} TAGEN AUSGEFÜHRT",
    "licenses": "Lizenzen",
    "license": "Lizenz",
    "customerSapId": "SAP-ID des Kunden",
    "customerPONumber": "Kundenauftragsnummer",
    "search_companies": "Unternehmen suchen",
    "month": "Monat",
    "year": "Jahr",
    "day": "Tag",
    "unknown": "Unbekannt",
    "assigning_account_to_order": "Auftrag dem Konto ... zuordnen...",
    "deploying_order": "Bestelle wird bereitgestellt...",
    "activating_order": "Bestellung wird aktiviert...",
    "error_assigning_order": "Es gab einen Fehler bei der Zuordnung des Auftrags zum Konto.",
    "error_deploying_order": "Es gab einen Fehler beim Bereitstellen der Bestellung.",
    "error_activating_order": "Es gab einen Fehler beim Aktivieren der Bestellung.",
    "cannot_comm_parent": "Wir können Sie nicht auf das richtige Formular umleiten, Sie können ein Konto über die Accounts App erstellen.",
    "no_results_found": "Keine Ergebnisse gefunden",
    "existing-subscription": "Zuweisung fehlgeschlagen: Dieses Unternehmen hat bereits eine Bestellung.",
    "0001": "Unzureichende Lizenzen. Die Anzahl der zugewiesenen kostenlosen Lizenzen ({free}) überschreitet die Anzahl der Lizenzen ({paid}) in der bezahlten Bestellung.",
    "restricted_view_warning": "Funktionen deaktiviert. Ihr Zugriff ist eingeschränkt."
  },
  "order_complete": {
    "go-to-account-integrations": "Zu den Kontointegrationen gehen",
    "go-to-account": "Zum Konto gehen",
    "activate-order": "Bestellung aktivieren",
    "order-added": "Auftrag hinzugefügt!",
    "order-deployed": "Bestellung bereitgestellt!",
    "order-activated": "Bestellung aktiviert!",
    "enable-integration": "Hinweis: Die in diesem Auftrag enthaltenen Artikel benötigen eine Integration und eine Einrichtung.",
    "activate-order-instructions": "Nur eine Anmerkung: Diese Bestellung muss aktiviert werden, um zu funktionieren."
  },
  "errors": {
    "504-general-message": "Die Lösung ist beschäftigt oder nicht erreichbar. Bitte versuchen Sie es erneut.",
    "couldnt-find-order": "Wir konnten die Bestellung in der Liste nicht finden. Bitte laden Sie die Seite erneut."
  }
}